import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { listingsAPI } from "@/lib/api/listings";

const CITIES = [
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Hyderabad",
  "Chennai",
  "Pune",
  "Kolkata",
  "Ahmedabad",
];

const CITY_ALIASES: Record<string, string[]> = {
  Hyderabad: ["hyderabad", "rangareddy", "secunderabad", "medchal"],
  Delhi: ["delhi", "new delhi", "noida", "gurgaon", "gurugram", "faridabad", "ghaziabad"],
  Bengaluru: ["bengaluru", "bangalore"],
  Mumbai: ["mumbai", "bombay", "thane", "navi mumbai"],
  Chennai: ["chennai", "madras"],
  Pune: ["pune", "pcmc"],
  Kolkata: ["kolkata", "calcutta"],
  Ahmedabad: ["ahmedabad", "gandhinagar"],
};

function getCityCount(city: string, counts: Record<string, number>): number {
  if (counts[city] !== undefined && counts[city] > 0) {
    return counts[city];
  }
  const aliases = CITY_ALIASES[city] || [city.toLowerCase()];
  let total = 0;
  for (const [key, count] of Object.entries(counts)) {
    const lowerKey = key.toLowerCase();
    if (aliases.some((alias) => lowerKey.includes(alias))) {
      total += count;
    }
  }
  return total;
}

export function Locations() {
  const [counts, setCounts] = useState<Record<string, number>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listingsAPI
      .getLocationCounts()
      .then((data) => setCounts(data))
      .catch(() => setCounts({}))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-4 py-6 md:py-8">
      <div className="mb-6">
        <h2 className="font-heading text-2xl font-bold text-foreground md:text-3xl">
          Popular locations
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Browse ads in India's most active cities.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
        {CITIES.map((city) => (
          <Link
            key={city}
            to={`/listings?location=${encodeURIComponent(city)}`}
            className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 transition hover:border-primary/30 hover:shadow-[var(--shadow-card)]"
          >
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-primary-soft text-primary">
              <MapPin className="h-5 w-5" />
            </span>
            <div>
              <div className="font-heading text-sm font-semibold text-foreground">
                {city}
              </div>
              {loading ? (
                <div className="mt-1 h-3 w-16 animate-pulse rounded bg-muted" />
              ) : (
                <div className="text-xs text-muted-foreground">
                  {getCityCount(city, counts).toLocaleString("en-IN")} ads
                </div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}